/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Event_Not_PlayedInputs */



/**
* | output |
* | --- |
* | "Not played yet" |
*
* @param {Meta_Event_Not_PlayedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_event_not_played = /** @type {((inputs?: Meta_Event_Not_PlayedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Event_Not_PlayedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht gespielt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore joué")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("尚未举行")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("尚未舉行")
	if (locale === "ko") return /** @type {LocalizedString} */ ("아직 열리지 않음")
	return /** @type {LocalizedString} */ ("Not played yet")
});